export enum Environment {
    DEV = 'dev',
    STAGING = 'staging',
    EVALUATION = 'evaluation',
    PRODUCTION = 'production'
}
